import React, { useState, useEffect } from 'react';
import SetDailyLimitHeader from './SetDailyLimitHeader';
import SetDailyLimitBody from './SetDailyLimitBody';
import SetDailyLimitFooter from './SetDailyLimitFooter';
import { useSelector, useDispatch } from 'react-redux';
import useFirebase from '../../../../useFirebase';
import { setRuleDataSetUp } from '../../AxiosRtk/SetRules';
import useLangTranslation from '../../../customHooks/languageProvider';

const SetDailyLimit = (props) => {
    const { getLangTranslation } = useLangTranslation();
    const {
        kidDevicesList,
    } = useSelector(({ dashboard }) => dashboard);

    const {
        setRulesData
    } = useSelector(({ setRules }) => setRules);
    const [deviceId, setDeviceId] = useState(kidDevicesList[0]?.ID);
    const dispatch = useDispatch();

    const {
        getCollectionData,
        postCollectionData,
        createCollectionData
    } = useFirebase();

    useEffect(() => {
        if (deviceId) {
            getCollectionData(deviceId);
        } else {
            dispatch(setRuleDataSetUp(null));
        }
    }, [deviceId])


    return (
        <>
            <SetDailyLimitHeader
                deviceId={deviceId}
                setDeviceId={setDeviceId}
                setRulesData={setRulesData}
                getLangTranslation = {getLangTranslation}
            />
            {
                deviceId ? (
                    <>
                        <SetDailyLimitBody
                            deviceId={deviceId}
                            setRulesData={setRulesData}
                            postCollectionData={postCollectionData}
                            getCollectionData={getCollectionData}
                            createCollectionData={createCollectionData}
                        />
                        {/* <SetDailyLimitFooter
                            deviceId={deviceId}
                            setRulesData={setRulesData}
                        /> */}
                    </>
                ) : (
                    <div className='text-center my-3'>
                        -- {getLangTranslation("DEVICE_NOT_SELECTED", "Device not selected")} --
                    </div>
                )
            }
        </>
    )
}

export default SetDailyLimit